import React from 'react';
import UserNavbar from './UserNavbar';
import bgImage from '../../assets/images/orange_banner.jpg';
import { useAppContext } from "../../context/AppContext";


function CollapsedHeader() {
    const { theme } = useAppContext();
    return (
        <>
            <div className="flex flex-col relative">
                <div
                    className={`bg-cover bg-center ${theme === 'dark' ? 'bg-black' : ''} transition-all duration-300 ease-in-out`}
                    style={theme === 'light' ? { backgroundImage: `url(${bgImage})` } : {}}
                >
                    <UserNavbar />
                </div>
            </div>
        </>
    );
}

export default CollapsedHeader;
